import { NoSymbolIcon } from '@heroicons/react/24/outline';

interface IUnauthorizedMessageProps {
  title: string;
  message: string;
}

const UnAuthorizedMessage = ({ title, message }: IUnauthorizedMessageProps) => {
  return (
    <section className='w-full flex justify-center items-center h-screen/2 bg-white'>
      <div className='max-w-lg text-center'>
        <div className='flex justify-center items-center gap-2 text-tertiaryColor-normal'>
          <NoSymbolIcon className='h-8 w-8' />
          <h1>{title}</h1>
        </div>
        <p>{message}</p>
      </div>
    </section>
  );
};

export default UnAuthorizedMessage;
